import { render, staticRenderFns } from "./AccountDialog.vue?vue&type=template&id=8fa0e314"
import script from "./AccountDialog.vue?vue&type=script&lang=js"
export * from "./AccountDialog.vue?vue&type=script&lang=js"
import style0 from "@/assets/scss/pages/pages.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "@/assets/scss/pages/setting.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports